import { Component, Input } from '@angular/core';

@Component({
  selector: 'msn-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.scss',
})
export class ProgressBarComponent {
  @Input() percentage: number = 0;
  @Input() size: string = 'sm';
  @Input() showValue: boolean = true;
}
